module.exports = __webpack_public_path__ + "img/bl.4386ae10.svg";